module.exports = __webpack_public_path__ + "static/img/AdobeStock_141425190.c6d2eb0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/subscribe/AdobeStock_141425190.jpeg
// module id = QZg6
// module chunks = 1